import { render, staticRenderFns } from "./TaskNewDialog.vue?vue&type=template&id=d2fab490&scoped=true"
import script from "./TaskNewDialog.vue?vue&type=script&lang=js"
export * from "./TaskNewDialog.vue?vue&type=script&lang=js"
import style0 from "./TaskNewDialog.vue?vue&type=style&index=0&id=d2fab490&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2fab490",
  null
  
)

export default component.exports